/* ==========================================================================
   GUAPI x LIL BABY — Drop Campaign Page JS
   Countdown, scroll reveal, sticky CTA, password gate, AJAX add-to-cart
   ========================================================================== */
(function(){
  "use strict";

  /* ---------------- Scroll reveal ---------------- */
  function initReveal(){
    var els = document.querySelectorAll('.guapi-lb-reveal');
    if(!els.length) return;
    if(!('IntersectionObserver' in window)){
      els.forEach(function(e){ e.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function(e){ io.observe(e); });
  }

  /* ---------------- Lazy video autoplay (perf) ---------------- */
  function initLazyVideo(){
    var vids = document.querySelectorAll('video[data-lb-lazy]');
    if(!vids.length) return;
    if(!('IntersectionObserver' in window)){
      vids.forEach(function(v){ v.play && v.play().catch(function(){}); });
      return;
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        var v = entry.target;
        if(entry.isIntersecting){
          if(v.dataset.lbSrcLoaded !== '1'){
            var src = v.querySelector('source');
            if(src && src.dataset.src){ src.src = src.dataset.src; v.load(); }
            v.dataset.lbSrcLoaded = '1';
          }
          v.play && v.play().catch(function(){});
        } else {
          v.pause && v.pause();
        }
      });
    }, { threshold: 0.2 });
    vids.forEach(function(v){ io.observe(v); });
  }

  /* ---------------- Countdown / live-now ---------------- */
  function initCountdowns(){
    var blocks = document.querySelectorAll('[data-lb-countdown]');
    blocks.forEach(function(block){
      var target = new Date(block.getAttribute('data-lb-countdown')).getTime();
      var liveEl = block.querySelector('[data-lb-live]');
      var gridEl = block.querySelector('[data-lb-grid]');
      var dEl = block.querySelector('[data-lb-d]');
      var hEl = block.querySelector('[data-lb-h]');
      var mEl = block.querySelector('[data-lb-m]');
      var sEl = block.querySelector('[data-lb-s]');

      function tick(){
        var now = Date.now();
        var diff = target - now;
        if(isNaN(target) || diff <= 0){
          if(gridEl) gridEl.style.display = 'none';
          if(liveEl) liveEl.style.display = 'inline-flex';
          clearInterval(timer);
          return;
        }
        if(liveEl) liveEl.style.display = 'none';
        if(gridEl) gridEl.style.display = 'flex';
        var d = Math.floor(diff / 86400000);
        var h = Math.floor((diff % 86400000) / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        if(dEl) dEl.textContent = String(d).padStart(2,'0');
        if(hEl) hEl.textContent = String(h).padStart(2,'0');
        if(mEl) mEl.textContent = String(m).padStart(2,'0');
        if(sEl) sEl.textContent = String(s).padStart(2,'0');
      }
      tick();
      var timer = setInterval(tick, 1000);
    });
  }

  /* ---------------- Sticky mobile CTA ---------------- */
  function initSticky(){
    var sticky = document.querySelector('[data-lb-sticky]');
    if(!sticky) return;
    var hero = document.querySelector('[data-lb-hero]');
    var revealAfter = hero ? hero.offsetHeight * 0.85 : 480;
    function onScroll(){
      if(window.scrollY > revealAfter){
        sticky.classList.add('is-visible');
      } else {
        sticky.classList.remove('is-visible');
      }
    }
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------------- AJAX Add to cart ---------------- */
  function initAddToCart(){
    document.addEventListener('click', function(e){
      var btn = e.target.closest('[data-lb-add-to-cart]');
      if(!btn) return;
      e.preventDefault();
      if(btn.dataset.state === 'loading' || btn.dataset.state === 'added') return;
      var variantId = btn.getAttribute('data-variant-id');
      if(!variantId){
        window.location.href = btn.getAttribute('data-fallback-url') || '#';
        return;
      }
      var originalText = btn.textContent;
      btn.dataset.state = 'loading';
      btn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
      .then(function(res){
        if(!res.ok) throw new Error('cart-add-failed');
        return res.json();
      })
            .then(function(){
        btn.dataset.state = 'added';
        btn.textContent = 'Added ✓';

        var cartDrawerEl = document.querySelector('cart-drawer');
        if(cartDrawerEl){
          fetch('/cart?section_id=cart-drawer')
            .then(function(res){ return res.text(); })
            .then(function(html){
              var parser = new DOMParser();
              var doc = parser.parseFromString(html, 'text/html');
              var newBody = doc.getElementById('CartDrawer-Body');
              var curBody = document.getElementById('CartDrawer-Body');
              if(newBody && curBody){ curBody.innerHTML = newBody.innerHTML; }
              if(typeof cartDrawerEl.open === 'function'){
                cartDrawerEl.open();
              } else {
                cartDrawerEl.classList.add('active', 'animate');
                document.body.classList.add('overflow-hidden');
              }
            })
            .catch(function(){
              if(typeof cartDrawerEl.open === 'function'){ cartDrawerEl.open(); }
            });
        }

        fetch('/cart.js')
          .then(function(r){ return r.json(); })
          .then(function(cart){
            var countEls = document.querySelectorAll('#cart-counter [data-cart-count], .cart-count, [data-cart-count]');
            countEls.forEach(function(el){ el.textContent = cart.item_count; });
          })
          .catch(function(){});

        document.dispatchEvent(new CustomEvent('cart:refresh'));
        try{
          window.dispatchEvent(new CustomEvent('cart:updated'));
        }catch(err){}
        setTimeout(function(){
          btn.dataset.state = '';
          btn.textContent = originalText;
        }, 2200);
      })

      .catch(function(){
        btn.dataset.state = '';
        btn.textContent = originalText;
        window.location.href = btn.getAttribute('data-fallback-url') || '/cart';
      });
    });
  }
  /* ---------------- Early access subscribe (Klaviyo) ---------------- */
  var LB_KLAVIYO_PUBLIC_KEY = "W9GfDD";
  var LB_KLAVIYO_LIST_ID = "UkLxpU";

  function lbToE164(raw){
    var d = (raw || "").replace(/[^\d+]/g, "");
    if (d.charAt(0) === "+") return d;
    if (d.length === 10) return "+1" + d;
    if (d.length === 11 && d.charAt(0) === "1") return "+" + d;
    return d ? "+" + d : "";
  }

  function initEarlyAccess(){
    var form = document.querySelector('[data-lb-early-form]');
    if(!form) return;
    form.addEventListener('submit', function(e){
      e.preventDefault();
      var wrap = form.closest('.guapi-lb-early');
      var msgEl = wrap.querySelector('[data-lb-early-msg]');
      var btn = form.querySelector('.guapi-lb-early__btn');
      var phoneRaw = form.phone.value.trim();
      var phone = lbToE164(phoneRaw);

      if(!phone || phone.length < 8){
        msgEl.hidden = false;
        msgEl.textContent = 'Please enter a valid phone number.';
        return;
      }

      msgEl.hidden = true;
      btn.disabled = true;
      btn.textContent = 'SIGNING UP…';

      var payload = {
        data: {
          type: 'subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: { phone_number: phone }
              }
            }
          },
          relationships: {
            list: { data: { type: 'list', id: LB_KLAVIYO_LIST_ID } }
          }
        }
      };

      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + LB_KLAVIYO_PUBLIC_KEY, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
        body: JSON.stringify(payload)
      })
      .then(function(res){
        if(res.ok || res.status === 202){
          wrap.classList.add('is-success');
          wrap.querySelector('.guapi-lb-early__title').textContent = "You're on the list. Watch your texts.";
          form.remove();
          try { window.fbq && fbq('track', 'Lead'); } catch(err){}
          try { window.gtag && gtag('event', 'Lead'); } catch(err){}
          try { window.ttq && ttq.track('SubmitForm'); } catch(err){}
        } else {
          throw new Error('klaviyo ' + res.status);
        }
      })
      .catch(function(){
        btn.disabled = false;
        btn.textContent = 'SIGN UP';
        msgEl.hidden = false;
        msgEl.textContent = 'Something went wrong. Please try again.';
      });
    });
  }


  /* ---------------- Password gate ---------------- */
  function initGate(){
    var gate = document.querySelector('[data-lb-gate]');
    if(!gate) return;
    var sectionId = gate.getAttribute('data-lb-gate-id');
    var storageKey = 'guapi_lb_unlocked_' + sectionId;
    var params = new URLSearchParams(window.location.search);

    if(params.get('preview') === '1'){
      document.documentElement.classList.add('guapi-gate-unlocked');
      return;
    }
    try {
      if(sessionStorage.getItem(storageKey) === '1'){
        document.documentElement.classList.add('guapi-gate-unlocked');
        return;
      }
    } catch(err){}

    var form = gate.querySelector('[data-lb-gate-form]');
    var input = gate.querySelector('[data-lb-gate-input]');
    var error = gate.querySelector('[data-lb-gate-error]');
    var encoded = gate.getAttribute('data-lb-gate-pass') || '';

    function decode(str){
      try { return decodeURIComponent(escape(window.atob(str))); }
      catch(err){ return ''; }
    }
    var correctPass = decode(encoded);

    if(form){
      form.addEventListener('submit', function(e){
        e.preventDefault();
        var val = (input.value || '').trim();
        if(val && correctPass && val.toLowerCase() === correctPass.toLowerCase()){
          try { sessionStorage.setItem(storageKey, '1'); } catch(err){}
          document.documentElement.classList.add('guapi-gate-unlocked');
          if(error) error.classList.remove('is-visible');
        } else {
          if(error) error.classList.add('is-visible');
          input.focus();
          input.select && input.select();
        }
      });
    }
  }

    /* ---------------- Size-aware quick add (product grid) ---------------- */
  function initSizePicker(){
    document.querySelectorAll('[data-lb-pcard]').forEach(function(card){
      var pills = card.querySelectorAll('[data-lb-size-pill]');
      if(!pills.length) return;
      var variantsEl = card.querySelector('[data-lb-variants]');
      var variants = [];
      try { variants = JSON.parse(variantsEl.textContent); } catch(err){}
      var btn = card.querySelector('[data-lb-add-to-cart]');
      pills.forEach(function(pill){
        if(pill.dataset.lbSizeInit === '1') return;
        pill.dataset.lbSizeInit = '1';
        pill.addEventListener('click', function(){
          if(pill.disabled) return;
          pills.forEach(function(p){ p.classList.remove('is-selected'); });
          pill.classList.add('is-selected');
          var size = pill.getAttribute('data-size-value');
          var match = variants.filter(function(v){ return v.size === size && v.available; })[0];
          if(match && btn){
            btn.setAttribute('data-variant-id', match.id);
            btn.disabled = false;
            btn.textContent = 'Quick Add';
          }
        });
      });
    });
  }

  /* ---------------- Load more (collection pagination) ---------------- */
  function initLoadMore(){
    document.addEventListener('click', function(e){
      var btn = e.target.closest('[data-lb-load-more]');
      if(!btn) return;
      e.preventDefault();
      var nextUrl = btn.getAttribute('data-next-url');
      var sectionId = btn.getAttribute('data-section-id');
      if(!nextUrl) return;
      btn.disabled = true;
      var originalText = btn.textContent;
      btn.textContent = 'Loading…';
      fetch(nextUrl + (nextUrl.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + sectionId)
        .then(function(res){ return res.text(); })
        .then(function(html){
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var newGrid = doc.querySelector('[data-lb-products-grid]');
          var newLoadMoreBtn = doc.querySelector('[data-lb-load-more]');
          var newCount = doc.querySelector('[data-lb-products-count]');
          var sectionEl = btn.closest('section');
          var curGrid = sectionEl ? sectionEl.querySelector('[data-lb-products-grid]') : null;
          var curCount = sectionEl ? sectionEl.querySelector('[data-lb-products-count]') : null;
          if(newGrid && curGrid){
            Array.prototype.slice.call(newGrid.children).forEach(function(card){ curGrid.appendChild(card); });
            initReveal();
            initLazyVideo();
            initSizePicker();
          }
          if(newCount && curCount){ curCount.textContent = newCount.textContent; }
          if(newLoadMoreBtn){
            btn.setAttribute('data-next-url', newLoadMoreBtn.getAttribute('data-next-url'));
            btn.disabled = false;
            btn.textContent = originalText;
          } else {
            btn.remove();
          }
        })
        .catch(function(){
          btn.disabled = false;
          btn.textContent = originalText;
        });
    });
  }

    function boot(){
    initReveal();
    initLazyVideo();
    initCountdowns();
    initSticky();
    initAddToCart();
    initGate();
    initSizePicker();
    initLoadMore();
    initEarlyAccess();
  }


  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
